import { observer } from 'mobx-react-lite';
import {
  DeliveryDescriptionContainer,
  DeliveryImg,
  ParcelDeliveryOptionContainer,
  DeliveryPriceContainer,
  DeliveryServiceName,
} from './parcel-delivery-option.styles';
import { getFormattedPrice } from '../../../../../utils/price/get-formatted-price';
import { useStore } from '../../../../../stores/store';
import { DeliveryOption } from '../../../../../models/delivery-options/delivery-option';
import { getPrice } from '../../../../../routes/parcel-delivery/helpers';

interface Props {
  deliveryOption: DeliveryOption;
}

const ParcelDeliveryOption = ({ deliveryOption }: Props) => {
  const {
    userStore: { getCurrencySymbol },
  } = useStore();

  const { first_miles: firstMiles } = deliveryOption;

  const firstMile = firstMiles?.at(0);

  if (!firstMile) return 0;

  const firstMileImgUrl = firstMile?.logo
    ? firstMile.logo
    : firstMile?.image ?? '';

  return (
    <ParcelDeliveryOptionContainer>
      <DeliveryDescriptionContainer>
        <DeliveryImg $imgUrl={firstMileImgUrl} />
        <DeliveryServiceName>{`${firstMile?.carrier.name} ${firstMile?.service.name}`}</DeliveryServiceName>
      </DeliveryDescriptionContainer>
      <DeliveryPriceContainer>
        {getFormattedPrice(
          getPrice(deliveryOption),
          getCurrencySymbol(firstMile.currency)
        )}
      </DeliveryPriceContainer>
    </ParcelDeliveryOptionContainer>
  );
};

export default observer(ParcelDeliveryOption);
